import { Component, inject, RendererFactory2, Type, ViewChild, ViewContainerRef, DOCUMENT, ChangeDetectionStrategy } from '@angular/core'
import { Subject } from 'rxjs'
import { RedirectorPaynowConfig, RedirectorService } from 'src/app/service/redirector.service'
import { ActivatedRoute } from '@angular/router'
import { NgComponentOutlet } from '@angular/common'
import { StructuredDataTag } from 'src/app/service/meta/structured.data'
import type { PriceSpecification, Product, WithContext } from 'schema-dts'
import { MetaKeyId, MetaService } from 'src/app/service/meta/meta.service'

@Component({
  selector: 'app-buy',
  imports: [
    NgComponentOutlet,
  ],
  templateUrl: './buy.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './buy.component.sass',
})
export class BuyComponent {
  protected update = new Subject<void>()
  // Loaded by buyComponentResolver before the page renders
  protected component: Type<any> | null = inject(ActivatedRoute).snapshot.data['component'] ?? null
  protected context = this.redirectorService.getContext()
  protected document = inject(DOCUMENT)
  protected metaService = inject(MetaService)
  @ViewChild('template', { static: true, read: ViewContainerRef }) templateRef!: ViewContainerRef

  constructor (
    protected redirectorService: RedirectorService,
  ) {
    const renderer = inject(RendererFactory2).createRenderer(null, null)

    if (
      this.context.config.type !== 'error'
      && this.context.config.type !== 'landing'
      && this.context.config.template !== 'sold'
    ) {
      renderer.addClass(inject(DOCUMENT).body, `e--color-${this.context.config.template_data['theme-color']}`)
    }

    if (['paynow', '4sale'].includes(this.context.config.type)) {
      const config = this.context.config as RedirectorPaynowConfig
      const price = config.price

      if (price) {
        const data: WithContext<Product> = {
          '@context': 'https://schema.org',
          "@type": "Product",
          image: config?.template_data?.image
            ? config.template_data.image
            : 'https://elitedomains.de/static/images/brand/open-graph.jpg',
          name: $localize`Domain: ` + config.display_name,
          description: $localize`Die Domain ${config.display_name}:domainName: steht zum Verkauf. Jetzt kaufen!`,
          offers: {
            '@type': 'Offer',
            price,
            priceCurrency: 'EUR',
            availability: 'https://schema.org/InStock',
            checkoutPageURLTemplate: `https://checkout.elitedomains.de/${this.context.i18n.locale}/${config.name}`,
            shippingDetails: {
              '@type': 'OfferShippingDetails',
              shippingRate: {
                '@type': 'MonetaryAmount',
                value: 0,
                currency: 'EUR'
              },
              deliveryTime: {
                '@type': 'ShippingDeliveryTime',
                handlingTime: {
                  '@type': 'QuantitativeValue',
                  minValue: 0,
                  maxValue: 1,
                  unitCode: 'DAY'
                },
                transitTime: {
                  '@type': 'QuantitativeValue',
                  minValue: 0,
                  maxValue: 1,
                  unitCode: 'DAY'
                }
              },
              shippingDestination: {
                '@type': 'DefinedRegion',
                name: 'Worldwide'
              },
              // @ts-ignore
              deliveryMethod: "https://schema.org/EmailDelivery"
            }
          },
        }

        if (config.template_data['price-suggest']) {
          // @ts-ignore
          data.offers.priceSpecification = {
            '@type': 'PriceSpecification',
            price,
            priceType: 'Negotiable',
          } as PriceSpecification
        }

        new StructuredDataTag('paynow-offer', data, renderer, this.document)
      }

      if (config?.template_data?.image) {
        this.metaService.addMeta('image' as MetaKeyId, config.template_data.image)
      }
    }
  }
}
